export const INIT_ANIMATION_DURATION_MS = 800;
export const CONTAINER_BORDER_WIDTH = 2;
export const TRACK_OFFSET = 2;
